//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Datepicker from './Datepicker';
import getInViewPosition from './getInViewPosition';

export default {
  props: {
    classDesign: { type: String, default: '' },
    dataVvRules: [String, Function, Object],
    disablePassedDays: { type: Boolean, default: false },
    disablePassedMonths: { type: Boolean, default: false },
    disablePreviousDays: { type: String, default: null },
    disabledDays: { type: Array, default() { return []; } },
    doubled: { type: Boolean, default: false },
    format: { type: String, default: 'DD/MM/YYYY' },
    id: { type: String, default: 'vue-datepicker' },
    label: String,
    lang: { type: String, default: 'pt-br' },
    name: { type: String, default: 'datepicker' },
    orientation: { type: String, default: 'portrait' },
    timepicker: { type: Boolean, default: false },
    value: { type: String, default: '' },
    vValidate: Boolean,
    required: { type: Boolean, default: false },
    dateIsClicked: { type: Boolean, default: false },
    tabindex: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      date: '',
      isVisible: false,
      parentName: '' || this.name,
      dateValue: '',
      eventListener: false,
    };
  },
  computed: {
    localModel() {
      return this.dateValue ? this.dateValue : this.formattedDate;
    },
    formattedDate() {
      return (this.date) ?
        this.date.format(this.format) :
        '';
    },
  },
  components: {
    Datepicker,
  },
  watch: {
    formattedDate() {
      if (this.formattedDate) {
        this.$emit('INPUTDATEPICKER_FORMATTED_DATE', this.formattedDate);
      }
    },
    date() {
      if (this.date) {
        this.$emit('INPUTDATEPICKER_DATE', this.date);
      }
    },
    value() {
      this.dateValue = this.value;
    },
  },
  methods: {
    selectDate(obj) {
      this.date = obj;
      this.dateValue = this.formattedDate;
      if (obj.dateIsClicked || this.dateIsClicked) {
        this.hideDatePicker();
      }
      this.validate();
    },
    getPosition(vertical, horizontal) {
      const menuTriggerRect = this.datepickerTrigger.getBoundingClientRect();
      // console.log(menuTriggerRect);
      const top = vertical === 'top'
        ? menuTriggerRect.top + (menuTriggerRect.height - this.menuContent.offsetHeight)
        : menuTriggerRect.top;
      const left = horizontal === 'left'
        ? menuTriggerRect.left - (this.menuContent.offsetWidth + menuTriggerRect.width)
        : menuTriggerRect.left;
      return { top, left };
    },
    calculateMenuContentPos() {
      this.isVisible = true;
      let position;
      position = this.getPosition('bottom', 'right');
      position = getInViewPosition(this.$refs.datepicker.$el, position);
      this.$refs.datepicker.$el.style.top = position.top + (window.pageYOffset + 28) + 'px'; // eslint-disable-line
      this.$refs.datepicker.$el.style.left = position.left + window.pageXOffset + 'px'; // eslint-disable-line
      this.$refs.datepicker.$el.style.zIndex = 10; // eslint-disable-line
      this.$refs.datepicker.$el.style.position = 'absolute'; // eslint-disable-line
    },
    showDatepickerEvent() {
      if (!this.isVisible) {
        this.showDatepicker();
      }
    },
    showDatepicker() {
      this.isVisible = true;
      setTimeout(() => {
        document.body.appendChild(this.$refs.datepicker.$el); // eslint-disable-line
        this.calculateMenuContentPos();
        this.addEventListenerHide();
      }, 1E2);
    },
    addEventListenerHide() {
      setTimeout(() => {
        if (!this.eventListener) {
          document.addEventListener('click', this.hideDatePicker); // eslint-disable-line
          this.eventListener = true;
        }
      }, 1E2);
    },
    hideDatePicker() {
      this.isVisible = false;
      document.body.removeChild(this.$refs.datepicker.$el); // eslint-disable-line
      document.removeEventListener('click', this.hideDatePicker); // eslint-disable-line
      this.eventListener = false;
    },
    cancelDateSelection() {
      this.hideDatePicker();
    },
    validate() {
      setTimeout(() => {
        this.$validator.validateAll();
      }, 1000);
    },
    doValidateAll() {
      return this.$validator.validateAll();
    },
  },
  mounted() {
    this.datepickerTrigger = this.$el.querySelector('#datepicker-trigger');
    this.errors.clear();
  },
  beforeDestroy() {
    if (this.isVisible) {
      this.hideDatePicker();
    }
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/datepicker/InputDatepicker.vue?vue&type=script&lang=js&